export const SET_EVENT = '[PWAAPP] SAVE INSTALL EVENT';
export const REMOVE_EVENT = '[PWAAPP] SAVE INSTALL EVENT';

export function setEvent(_AEvent)
{
  return {
    type: SET_EVENT,
    payload: _AEvent
  }
}
